import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { Account } from "@/features/accounts";
import { HydraErrorResponse } from "@/types";
import { useOnQueryError } from "@/hooks";
import AuthService from "../services/auth-service/auth-service";

export const useGetAccountDetails = (accountId: number | null) => {
  const onError = useOnQueryError("auth.get_account_details_default_error");

  return useQuery<Account, AxiosError<HydraErrorResponse>>({
    queryKey: ["account", accountId],
    queryFn: () => AuthService.getAccountDetails(accountId),
    refetchOnWindowFocus: false,
    enabled: accountId !== null,
    meta: {
      onError,
    },
  });
};
